export interface DiscountCode {
  type: "percent" | "euro"
  value: number // percent [1-100] or cent [>1]
  countUsed: number
  limitUses: number // 0 for unlimited
  active: boolean
  neededMinOrderValue: number // cent
  availableOrderModes: Array<"all" | "pickup" | "delivery" | "shipping" | string> // OR combined logic to add multiple DistOptions
  code: string // Was implicitly added
}

export const createDefaultDiscountCode: () => DiscountCode = () => ({
  type: "percent",
  value: 10,
  countUsed: 0,
  limitUses: 0,
  active: true,
  neededMinOrderValue: 0,
  availableOrderModes: ["all"],
  code: "",
})

export default DiscountCode
